export default "__VITE_ASSET__Cc$Em1ni__"